import { getOrg } from "utils/site";

export enum limitsEnumFra {
  Mini = 100000,
  Midi = 200000,
  Maxi = 300000,
}

export enum limisEnumGer {
  OP = 0,
  Mini = 100000,
  Midi = 200000,
  Maxi = 300000,
}

export const getLimits = () => {
  const org = getOrg();

  switch (org) {
    case "fra":
      return [limitsEnumFra.Mini, limitsEnumFra.Midi, limitsEnumFra.Maxi];

    default:
      throw new Error(`No limits found for org ${org}`);
  }
};
